import { IAddressValidationResult } from "Model/Omikron/IAddressValidationResult";
import { IState } from "Model/State/IState";
import { IProject } from "Model/Storage/IProject";

export function selectShowAddressValidationDialog(state: IState): boolean {
  return state.omikron.av.showDialog;
}

export function selectAddressValidationResults(state: IState): IAddressValidationResult[][] {
  return state.omikron.av.results;
}

export function selectAddressValidationCache(state: IState): IProject {
  return state.omikron.av.cache;
}

export function selectAddressValidationActiveProjectId(state: IState): string {
  return state.omikron.av.activeProjectId;
}

export function selectAddressValidationActiveProjectItemId(state: IState): string {
  return state.omikron.av.activeProjectItemId;
}
